export const PERMISSION_RESOURCE_CODES = {
  projectWorkbench: 'project-workbench',
  globalBoards: 'global-boards',
  globalGantt: 'global-gantt',
  projectList: 'project-list',
  resourceCenter: 'resource-center',
  resourceMemberDetail: 'resource-member-detail',
  calendar: 'calendar',
  globalRisks: 'global-risks',
  analytics: 'analytics',
  permission: 'permission',
  dictionary: 'dictionary',
  aiModelBinding: 'ai-model-binding',
  myTasks: 'my-tasks',
  myProjects: 'my-projects',
  projectDashboard: 'project-dashboard',
  templateCenter: 'template-center',
  templateDetail: 'template-detail',
  projectDetail: 'project-detail',
  projectOverview: 'project-overview',
  projectGantt: 'project-gantt',
  projectKanban: 'project-kanban',
  projectFileContract: 'project-file-contract',
  projectCommunication: 'project-communication',
  projectAcceptance: 'project-acceptance',
  projectIssues: 'project-issues',
  projectReports: 'project-reports',
  projectReview: 'project-review',
  projectMembers: 'project-members',
  projectWorkHours: 'project-work-hours',
  projectActivities: 'project-activities',
  taskDetail: 'task-detail',
} as const;

export const PERMISSION_ACTION_CODES = {
  projectWorkbench: {},
  globalBoards: { edit: 'edit' },
  globalGantt: {},
  projectList: { create: 'create', edit: 'edit', disable: 'disable' },
  resourceCenter: {},
  resourceMemberDetail: {},
  calendar: {},
  globalRisks: {},
  analytics: {},
  permission: { manage: 'manage' },
  dictionary: { create: 'create', edit: 'edit', delete: 'delete' },
  aiModelBinding: { manage: 'manage' },
  myTasks: {},
  myProjects: {},
  projectDashboard: {},
  templateCenter: {
    create: 'create', edit: 'edit', enable: 'enable', disable: 'disable', manage: 'manage',
  },
  templateDetail: { create: 'create', edit: 'edit', manage: 'manage' },
  projectDetail: { edit: 'edit', manage: 'manage' },
  projectOverview: {},
  projectGantt: { create: 'create', edit: 'edit', manage: 'manage' },
  projectKanban: { create: 'create', edit: 'edit' },
  projectFileContract: { create: 'create', edit: 'edit', upload: 'upload', delete: 'delete' },
  projectCommunication: {},
  projectAcceptance: {
    createAcceptance: 'create-acceptance', editAcceptance: 'edit-acceptance',
    deleteAcceptance: 'delete-acceptance', submitAcceptance: 'submit-acceptance',
    createRectifyItem: 'create-rectify-item', editRectifyItem: 'edit-rectify-item',
    deleteRectifyItem: 'delete-rectify-item', createFollowPlan: 'create-follow-plan',
    editFollowPlan: 'edit-follow-plan', deleteFollowPlan: 'delete-follow-plan',
    uploadAttachment: 'upload-attachment', deleteAttachment: 'delete-attachment',
    createTaskFromRectifyItem: 'create-task-from-rectify-item',
    createTaskFromFollowPlan: 'create-task-from-follow-plan',
  },
  projectIssues: { create: 'create', edit: 'edit', manage: 'manage' },
  projectReports: { create: 'create', edit: 'edit', submit: 'submit' },
  projectReview: {
    createReview: 'create-review', createActionItem: 'create-action-item',
    editActionItem: 'edit-action-item', createMemberRecord: 'create-member-record',
    editConclusion: 'edit-conclusion', generateMaterials: 'generate-materials',
    generateConclusion: 'generate-conclusion', confirmReview: 'confirm-review',
  },
  projectMembers: {},
  projectWorkHours: { create: 'create', edit: 'edit', delete: 'delete' },
  projectActivities: {},
  taskDetail: { edit: 'edit' },
} as const;

export type PermissionResourceCode =
  (typeof PERMISSION_RESOURCE_CODES)[keyof typeof PERMISSION_RESOURCE_CODES];

export const getAllPermissionKeys = () => [
  ...Object.values(PERMISSION_RESOURCE_CODES),
  ...Object.entries(PERMISSION_ACTION_CODES).flatMap(([resourceName, actions]) => {
    const resourceCode = PERMISSION_RESOURCE_CODES[
      resourceName as keyof typeof PERMISSION_RESOURCE_CODES
    ];
    return Object.values(actions).map((action) => `${resourceCode}:${action}`);
  }),
];
